export default __webpack_public_path__ + "static/media/default-thumbnail.94612b58.svg";